// Footer columns that collapse on mobile: the first block (the heading) opens and closes the rest.
(() => {
  if (window.themeFooter) return; // the theme editor can run this file again
  window.themeFooter = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const chevron = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="m6 9 6 6 6-6"/></svg>';

  const sync = (column) => {
    const toggle = column.querySelector(':scope > .footer-column__content > :first-child');
    if (!toggle) return;
    if (mobile.matches) {
      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-expanded', column.hasAttribute('data-open'));
    } else {
      ['role', 'tabindex', 'aria-expanded'].forEach((name) => toggle.removeAttribute(name));
    }
  };

  // Smoothly (assets/motion.js): open = grow to the full height; close = shrink to the heading, then hide the rest.
  const setOpen = (column, open, smooth = true) => {
    const motion = window.theme?.motion;
    const from = column.getBoundingClientRect().height;
    if (open) {
      column.removeAttribute('data-closing');
      column.toggleAttribute('data-open', true);
      sync(column);
      if (smooth) motion?.height(column, from, column.getBoundingClientRect().height, 300);
      return;
    }
    const toggle = column.querySelector(':scope > .footer-column__content > :first-child');
    const style = getComputedStyle(column);
    const to = toggle ? toggle.getBoundingClientRect().bottom - column.getBoundingClientRect().top + parseFloat(style.paddingBottom) + parseFloat(style.borderBottomWidth) : 0;
    const done = () => { column.removeAttribute('data-closing'); column.toggleAttribute('data-open', false); sync(column); };
    if (!smooth || !motion || motion.off()) { done(); return; }
    column.setAttribute('data-closing', '');
    motion.height(column, from, to, 300, done);
  };

  const init = (root = document) => {
    root.querySelectorAll('.footer-column[data-collapsible]:not([data-ready])').forEach((column) => {
      // a block's own font (<style> with @font-face) can come before its element: move style tags to the end so the
      // heading is the first child (font rules work from anywhere)
      const content = column.querySelector(':scope > .footer-column__content');
      if (content) content.querySelectorAll(':scope > style, :scope > link').forEach((tag) => content.append(tag));
      const toggle = column.querySelector(':scope > .footer-column__content > :first-child');
      if (!toggle || !column.querySelector(':scope > .footer-column__content > :nth-child(2)')) return;
      const icon = document.createElement('span');
      icon.className = 'icon footer-column__toggle';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = chevron;
      toggle.append(icon);
      column.setAttribute('data-ready', '');
      sync(column);
    });
  };

  document.addEventListener('click', (event) => {
    const column = event.target.closest?.('.footer-column[data-collapsible][data-ready]');
    if (!column || !mobile.matches) return;
    const toggle = column.querySelector(':scope > .footer-column__content > :first-child');
    if (!toggle.contains(event.target) || event.target.closest('a')) return;
    setOpen(column, !column.hasAttribute('data-open') || column.hasAttribute('data-closing'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const toggle = event.target.closest?.('.footer-column[data-collapsible][data-ready] > .footer-column__content > :first-child[role="button"]');
    if (!toggle || event.target !== toggle) return;
    event.preventDefault();
    const column = toggle.closest('.footer-column');
    setOpen(column, !column.hasAttribute('data-open') || column.hasAttribute('data-closing'));
  });

  mobile.addEventListener('change', () => document.querySelectorAll('.footer-column[data-ready]').forEach(sync));

  // Theme editor: open a column when one of its blocks is selected, and set up re-rendered footers.
  document.addEventListener('shopify:block:select', (event) => {
    const column = event.target.closest?.('.footer-column[data-collapsible]');
    if (column && event.target !== column) setOpen(column, true, false);
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  init();
})();
